// test1927
(1927 && 0);
